import React, { useEffect, useRef } from "react";
import "./Visi.css";
import imgVisi from "../../assets/image/img-visi.png";

const Visi = () => {

const imgRef = useRef();

  const handleScroll = () => {
    if (imgRef.current) {
      const scrollY = window.scrollY || window.pageYOffset;
      imgRef.current.style.setProperty("--scroll", scrollY);
    }
  };

  useEffect(() => {
    const smoothScroll = () => {
      handleScroll();
      requestAnimationFrame(smoothScroll);
    };

    window.addEventListener("scroll", handleScroll);
    smoothScroll(); // Memanggil fungsi smoothScroll untuk pertama kali

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className='container-visi'>
        <div className='container-img-visi'>
          <img
            ref={imgRef}
            src={imgVisi}
            alt=''
            srcset=''
            className='img-visi'
          />
        </div>

        <div className='container-articel'>
          <div className='box-article'>
            <div className='article-left'>
              <h1 className='title-article-visi'>Visi</h1>
              <p className='article-visi'>
                "Menjadi lingkungan RT yang berdaya saing, berkelanjutan, dan
                ramah lingkungan melalui pemanfaatan teknologi untuk
                meningkatkan kualitas hidup warga dan
                mendukung pertumbuhan ekonomi yang berkelanjutan."
              </p>
            </div>
            <div className='article-right'>
              <h1 className='title-article-visi'>Misi</h1>
              <p className='article-visi'>
                "Kami berkomitmen untuk menjadikan teknologi sebagai senjata
                keren kami dalam melindungi planet ini. Dengan semangat inovasi"
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Visi;
